import axios from "axios";
import { getTeamsAppDomain, networkErrorMessaging } from "./utils";

export const teamsServerBaseUrl = getTeamsAppDomain();

const axiosInstance = axios.create();
axiosInstance.interceptors.response.use(null, error => {
    networkErrorMessaging('NetworkError');
    throw error;
});

export async function sendNotification(data) {
    const url = `${teamsServerBaseUrl}/notification/send`;
    return axiosInstance.post(url, data);
}

export async function getFoxitToken(email: string) {
    return axiosInstance.get(`${teamsServerBaseUrl}/online/fetchFoxitToken?teamsEmail=${email}`);
}

export async function signOutFoxit(email: string) {
    return axiosInstance.put(`${teamsServerBaseUrl}/online/signOutFoxit`, { teamsEmail: email });
}

export async function getMSGraphToken(email: string) {
    return axiosInstance.get(`${teamsServerBaseUrl}/online/fetchGraphToken?teamsEmail=${email}`);
}
